export enum Sex {
  MALE = 1,
  FEMALE = 2
}
